import script from "./MobileUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileUpload.vue?vue&type=script&lang=ts&setup=true"

import "./MobileUpload.vue?vue&type=style&index=0&id=e32c0f5e&lang=scss&scoped=true"

import exportComponent from "/Users/jdmacminim61/Workspace/golfourit_ec_system/ec-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e32c0f5e"]])

export default __exports__